module.exports = __webpack_public_path__ + "60990b7f41e1db3eee0a3add7a6c38bd.svg";